/* global bootstrap */
document.addEventListener('added-to-cart', (el) => {
  if (!el.detail.instantCheckout && !el.detail.showRemoveLink) {
    setTimeout(() => {
      const dropdown = document.querySelector('.cart-dropdown');
      dropdown?.removeAttribute('aria-describedby');
      const ele = new bootstrap.Dropdown(dropdown);
      if (ele) {
        const message = dropdown.querySelector('mhecomm-message');
        const quantity = message?.shadowRoot?.querySelector('[part="cart-size"]');
        if (quantity) {
          quantity.id = 'cart-quantity';
          dropdown.setAttribute('aria-describedby', quantity.id);
        }
        ele.show();
      }
      if (!ele._menu || !ele._menu.classList) {
        return;
      }
    }, 100);
  }
});

window.addEventListener('load', () => {
  if (new URL(document.URL).searchParams.has('tid')) {
    document.querySelector('mhecomm-cart-preview')?.mergeCart(new URL(document.URL).searchParams.get('tid'));
  }
});
